"use client";

import { NAVBAR_ITEMS, STANDARD_MOBILE_RATIO, TRANSACTION_TYPE } from "@/common/const";
import adjustTBKColor from "@/common/function/adjustColor";
import compareDates from "@/common/function/compareDate";
import convertToSnakeCase from "@/common/function/convertToSnakeCase";
import createKey from "@/common/function/createKey";
import fetchAffSettingSetting from "@/common/function/fetchAffSetting";
import fetchAutoRouteSetting from "@/common/function/fetchAutoRouteSetting";
import fetchCurrenciesData from "@/common/function/fetchCurrenciesData";
import fetchIconsData from "@/common/function/fetchIconsData";
import fetchKycSetting from "@/common/function/fetchKycSetting";
import fetchLanguageData from "@/common/function/fetchLanguageData";
import fetchNetworkSetting from "@/common/function/fetchNetworkSetting";
import fetchOtpComfirmationsSetting from "@/common/function/fetchOtpComfirmationsSetting";
import fetchPoolStakeSetting from "@/common/function/fetchPoolStakeSetting";
import fetchQuestionSetting from "@/common/function/fetchQuestionSetting";
import fetchSettingGeneral from "@/common/function/fetchSettingGeneral";
import fetchTermOfUseData from "@/common/function/fetchTermOfUseData";
import fetchWalletSetting from "@/common/function/fetchWalletSetting";
import getLocaleInLocal from "@/common/function/getLocaleInLocal";
import getStatusBarHeightFromLocal from "@/common/function/getStatusBarHeightFromLocal";
import { GeneralPropsType } from "@/common/types";
import ComingSoonContent from "@/components/ComingSoonContent";
import ModalLayout from "@/components/ModalLayout";
import { ButtonStatus } from "@/components/PrimaryButton";
import { Fee } from "@/components/SubPaymentFeeInfo";
import getAppVersionInfo from "@/services/getAppVersionInfo";
import { LockTime } from "@/types/campaign";
import { Coupon, CouponList } from "@/types/coupon";
import { InvestRound, Nft } from "@/types/investRound";
import { ContractHistory } from "@/types/reward";
import { PaymentOption } from "@/types/subPayment";
import { UserInfo } from "@/types/user";
import { Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import { initHapticFeedback, initSwipeBehavior } from "@telegram-apps/sdk";
import { isTMA } from "@tma.js/sdk";
import { usePathname, useRouter } from "next/navigation";
import { createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
type LanguageType = Record<string, Record<string, string>>;
type IconsDataType = Record<string, string>;
export const GlobalContext = createContext<any>(null);
function GlobalDataProvider({
  children
}: GeneralPropsType) {
  // useInitializeGlobalData();
  const defaultDate = {
    startDate: "",
    endDate: "",
    key: "selection"
  };
  const router = useRouter();
  const pathname = usePathname();
  const [languageData, setLanguageData] = useState<LanguageType | undefined>();
  const [iconsData, setIconsData] = useState<IconsDataType | undefined>(undefined);
  const [showNavbar, setShowNavbar] = useState(true);
  const [submitKYCStatus, setSubmitKYCStatus] = useState<ButtonStatus>("normal");
  const [hideLanding, setHideLanding] = useState(false);
  const [selectedFriend, setSelectedFriend] = useState<any>(undefined);
  const [transaction, setTransaction] = useState<any>();
  const [detailPageAnimation, setDetailPageAnimation] = useState<"left_to_right" | "right_to_left">("right_to_left");
  const poolStakeSetting = useRef<any>();
  const affSettingData = useRef<any>();
  const tokensRate = useRef<any>();
  const [isSubmitKyc, setIsSubmitKyc] = useState(false);
  const [teleBackButton, setTeleBackButton] = useState<any>();
  const [coupponsData, setCoupponsData] = useState<CouponList | undefined>();
  const [giftCardsData, setGiftCardsData] = useState<any | undefined>();
  const [appVersionInfo, setAppVersionInfo] = useState<any>();
  const [questionsData, setQuestionsData] = useState<any>();
  const [campaignsData, setCampaignsData] = useState<any>(undefined);
  const adjustTimeout = useRef<any>();
  const [isCheckedTermOfUse, setIsCheckedTermOfUse] = useState(false);
  const [isCheckedTermOfUseConnectBank, setIsCheckedTermOfUseConnectBank] = useState(false);
  const [isCheckedContract, setIsCheckedContract] = useState(false);
  const [activityData, setActivityData] = useState<any>(undefined);
  const [routeSetting, setRouteSetting] = useState<any>();
  const [referralData, setReferralData] = useState<any>(undefined);
  const [affiliateData, setAffiliateData] = useState<any>(undefined);
  const [affiliateDataOverview, setAffiliateDataOverview] = useState<any>(undefined);
  const [kycData, setKycData] = useState<any>(undefined);
  const [countriesData, setCountriesData] = useState<any>(undefined);
  const [countriesKYCData, setCountriesKYCData] = useState<any>();
  const [documentsKYCData, setDocumentsKYCData] = useState<any>();
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [documentsByCountry, setDocumentsByCountry] = useState<any>();
  const [selectedDocument, setSelectedDocument] = useState<any>();
  const [kycDataUpload, setKYCDataUpload] = useState<any>();
  const [acceptKYC, setAcceptKYC] = useState(false);
  const [kycImages, setKycImages] = useState<any>();
  const [preKycImagesSubmit, setPreKycImagesSubmit] = useState<any>();
  const [kycDataUser, setKycDataUser] = useState<any>();
  const [generalAffiliateData, setGeneralAffiliateData] = useState<any>(undefined);
  const [imageData, setImageData] = useState<any>(undefined);
  const [otpComfirmationData, setOtpComfirmationData] = useState<any>(undefined);
  const [autoSub, setAutoSub] = useState<boolean>(false);
  const [isAccessByAffLink, setIsAccessByAffLink] = useState<boolean>(false);
  const [expendedAffiliateMember, setExpendedAffiliateMember] = useState<any>();
  const [boostAprData, setBoostAprData] = useState<any>();
  const [subPaymentFeeData, setSubPaymentFeeData] = useState<Fee[]>([]);
  const [affiliateDataHistory, setAffiliateDataHistory] = useState<any[]>();
  const [affiliateViewing, setAffiliateViewing] = useState<any>();
  const [rankData, setRankData] = useState<any>();
  const [maxoutData, setMaxoutData] = useState<any>(undefined);
  const [hapticFeedback, setHapticFeedback] = useState<any>(undefined);
  const [renderImages, setRenderImages] = useState<any[]>();
  const [docData, setDocData] = useState<any>();
  const [globalKycData, setGlobalKycData] = useState<{
    [key: string]: any;
  }>({});
  const [userInfo, setUserInfo] = useState<UserInfo | undefined>();
  const [overriedOpen, setOverriedOpen] = useState(false);
  const [chartData, setChartData] = useState<any>(undefined);
  const [selectedCardGlobal, setSelectedCardGlobal] = useState<any>(undefined);
  const [portfolioData, setPortfolioData] = useState<any>(undefined);
  const [announcementData, setAnnouncementData] = useState<any>(undefined);
  const [currenciesData, setCurrenciesData] = useState<any>(undefined);
  const [connectedSocialsData, setConnectedSocialsData] = useState<any>(undefined);
  const [portfolioProfitData, setPortfolioProfitData] = useState<any>(undefined);
  const [portfolioAmountData, setPortfolioAmountData] = useState<any>(undefined);
  const [contractHistory, setContractHistory] = useState<ContractHistory[] | undefined>(undefined);
  const [checkManagementPackageData, setCheckManagementPackageData] = useState<any>(undefined);
  const [rankTermOfServiceData, setRankTermOfServiceData] = useState<Record<string, any> | undefined>();
  const [unsignedSignature, setUnsignedSignature] = useState<any>(undefined);
  const [isSignaturePadEmpty, setIsSignaturePadEmpty] = useState<boolean>(true);
  const [investRounds, setInvestRounds] = useState<InvestRound | undefined>(undefined);
  const [isCheckKycForBonus, setIsCheckKycForBonus] = useState<boolean>(false);
  const [loadingSignature, setLoadingSignature] = useState(false);
  const [authenInfo, setAuthenInfo] = useState<AuthenticationInfo | undefined>(undefined);
  const [check2FA, setCheck2FA] = useState<any>(undefined);
  const [userWallets, setUserWallets] = useState<any>(undefined);
  const [sharedCoupons, setSharedCoupons] = useState<Coupon[] | undefined>(undefined);
  const [rewardFilterTab, setRewardFilterTab] = useState<"today" | "week" | "month">("week");
  const [nft, setNft] = useState<Nft[] | undefined>(undefined);
  const [personalNft, setPersonalNft] = useState<Nft[] | undefined>(undefined);
  const [selectedCouponForSend, setSelectedCouponForSend] = useState<Coupon | undefined>(undefined);
  const [selectedCouponForUse, setSelectedCouponForUse] = useState<Coupon | undefined>(undefined);
  const [deviceInfo, setDeviceInfo] = useState<any>();
  const [meDevice, setMeDevice] = useState<any>();
  const [amountDatesSelected, setAmountDatesSelected] = useState<any>(defaultDate);
  const [profitDatesSelected, setProfitDatesSelected] = useState<any>(defaultDate);
  const [currentDevice, setCurrentDevice] = useState<any>();
  const currentDeviceRef = useRef<any>();
  const [isSendGif, setIsSendGif] = useState(false);
  const [isUseBiometryForPinCode, setIsUseBiometryForPinCode] = useState<boolean>();
  const [NFTNetworkSelected, setNFTNetworkSelected] = useState<any>();
  const [mediaToCreateNFT, setMediaToCreateNFT] = useState<any>();
  const [appliedGiftCard, setAppliedSelectedGiftCard] = useState<any>();
  const [missionsData, setMissionsDataV2] = useState<any>();
  const [hideBottomNavbar, setHideBottomNavbar] = useState(false);
  const [cycleVestingClaimed, setCycleVestingClaimed] = useState<any>();
  const [isOpenGiftCardModal, setIsOpenGiftCardModal] = useState<boolean>(false);
  const [activityDetail, setActivityDetail] = useState<any>(null);
  const [reviewActivityCardData, setReviewActivityCardData] = useState<any>(null);
  const [activeActivityTypeActive, setActiveActivityTypeActive] = useState<string[]>([]);
  const [page, setPage] = useState(1);
  const [pageMission, setPageMission] = useState(1);
  const [suggestedFriends, setSuggestedFriends] = useState<any[] | undefined>(undefined);
  const [isPrefetchingSuggestedFriends, setIsPrefetchingSuggestedFriends] = useState(false);
  const [statusBarHeight, setStatusBarHeight] = useState<number | undefined>(0);
  const [isLimitSize, setIsLimitSize] = useState<boolean>(false);
  const [couponTabs, setCouponTabs] = useState<any>(undefined);
  const [appliedCoupon, setAppliedCoupon] = useState<Coupon | undefined>(undefined);
  const [selectedPresaleToken, setSelectedPresaleToken] = useState<any>();
  const [boostAmount, setBoostAmount] = useState("");
  const [clickedActivity, setClickedActivity] = useState<any>(null);
  const [detailTransactionData, setDetailTransactionData] = useState<any>([]);
  const [isMobileApp, setIsMobileApp] = useState<boolean>(false);
  const [limitInvest, setLimitInvest] = useState<boolean>(false);
  const [richtextData, setRichtextData] = useState<any>();
  const [screenSize, setScreenSize] = useState<{
    width: number;
    height: number;
    realWidth: number;
    realHeight: number;
  }>({
    width: 390,
    height: 844,
    realWidth: 390,
    realHeight: 844
  });
  const [selectedLockTime, setSelectedLockTime] = useState<string | undefined>(undefined);

  // Sub-payment
  const [selectedPayment, setSelectedPayment] = useState<PaymentOption | undefined>(undefined);
  const [packageInfo, setPackagesInfo] = useState<{
    available_reward?: string;
    total_investment?: string;
  } | undefined>(undefined);
  const [packagePagination, setPackagePagination] = useState<{
    page: number;
    limit: number;
    type: TRANSACTION_TYPE;
  }>({
    limit: 3,
    page: 1,
    type: TRANSACTION_TYPE.ALL
  });
  const [packageLoading, setPackageLoading] = useState(false);
  const {
    isOpen: isOpenConfirmPresale,
    onOpen: onOpenConfirmPresale,
    onOpenChange: onOpenChangeConfirmPresale,
    onClose: onCloseConfirmPresale
  } = useDisclosure();
  const {
    isOpen: isOpenComingSoon,
    onOpen: onOpenComingSoon,
    onOpenChange: onComingSoonChange,
    onClose: closeComingSoon
  } = useDisclosure();
  const setMissionsData = (data: any) => {
    setMissionsDataV2(convertToSnakeCase(data));
  };
  useEffect(() => {
    let times = 0;
    const interval = setInterval(() => {
      times++;
      const isMobileApp = localStorage.getItem("isMobileApp");
      if (isMobileApp == "true") {
        setIsMobileApp(true);
        clearInterval(interval);
        return;
      }
      if (times > 10) {
        setIsMobileApp(false);
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const paths = pathname?.split("/");
    if (!isMobileApp || paths?.includes("portfolio") || paths?.includes("reward") || paths?.includes("mission") || paths?.includes("community-mission")) {
      return setStatusBarHeight(0);
    }
    const statusBarHeightFromApp = getStatusBarHeightFromLocal();
    return setStatusBarHeight(statusBarHeightFromApp);
  }, [pathname]);
  const handleLimitSize = () => {
    // return;
    const w = window.innerWidth;
    const h = window.innerHeight;
    const isLimitSize = w / h > 1 && w > 900;
    setIsLimitSize(isLimitSize);
    if (!isLimitSize) return;
    document.body.style.backgroundImage = "linear-gradient(to top, #0e1d30, #152131, #2d384a)";
    const realHeight = h;
    // setStatusBarHeight(2.5 * 0.01 * h);
    setScreenSize({
      width: w,
      height: h,
      realWidth: STANDARD_MOBILE_RATIO * realHeight,
      realHeight: realHeight
    });
  };
  useEffect(() => {
    handleLimitSize();
    window.addEventListener("resize", handleLimitSize);
    window.addEventListener("orientationchange", handleLimitSize);
    return () => {
      window.removeEventListener("resize", handleLimitSize);
      window.removeEventListener("orientationchange", handleLimitSize);
    };
  }, []);
  useEffect(() => {
    if (!userInfo?.settings?.locale) return;
    localStorage.setItem("locale", userInfo?.settings?.locale);
  }, [userInfo]);
  const translate = (key: string, numCharAllow?: number) => {
    try {
      // return key;
      key = createKey(key);
      if (!languageData) return key;
      const locales = Object.keys(languageData);
      const {
        bcp47locale
      } = getLocaleInLocal();
      const preLocale = userInfo?.settings?.locale || bcp47locale || "";
      const userLocale = locales?.includes(preLocale) ? preLocale : locales?.[0];
      const rs = languageData?.[userLocale]?.[key] ?? key;
      const rsLowercase = (languageData?.[userLocale]?.[key] ?? key).toLowerCase();
      if (rsLowercase.includes("tkb") || rsLowercase.includes("wab") || rsLowercase.includes("usdt")) {
        if (!!adjustTimeout.current) {
          clearTimeout(adjustTimeout.current);
        }
        adjustTimeout.current = setTimeout(() => {
          adjustTBKColor();
        }, 300);
      }
      if (!!numCharAllow && rs.length >= numCharAllow) {
        return rs.slice(0, numCharAllow) + "...";
      }
      return rs;
    } catch (err) {
      return createKey(key);
    }
  };
  const getIcon = (key: string) => {
    try {
      if (!iconsData) return `/icons/${key}.svg`;
      return iconsData[key] ? `${iconsData[key]}` : `/icons/${key}.svg`;
    } catch (err) {
      console.error("Error getting icon", err);
      return `/icons/${key}.svg`;
    }
  };
  const getImageFromCMS = (key: string, format?: string) => {
    try {
      if (!iconsData) return `/images/${key}.${format ?? "png"}`;
      return iconsData[key] ? `${iconsData[key]}` : `/images/${key}.${format ?? "png"}`;
    } catch (err) {
      console.error("Error getting image", err);
      return `/images/${key}.${format ?? "png"}`;
    }
  };
  const triggerHapticFeedBack = (type: "success" | "error" | "warning" | "custom") => {
    try {
      const hapticFeedback = initHapticFeedback();
      type != "custom" && hapticFeedback.notificationOccurred(type || "success");
      return hapticFeedback;
    } catch (error) {
      console.log("Not support on website");
    }
  };
  useEffect(() => {
    try {
      let languageDataFromLocal: any = localStorage.getItem("language");
      if (!!languageDataFromLocal) {
        languageDataFromLocal = JSON.parse(languageDataFromLocal);
        !languageData && setLanguageData(languageDataFromLocal);
      }
    } catch (err) {
      console.log("🚀 ~ useEffect ~ err:", err);
    }
  }, []);
  useEffect(() => {
    try {
      if (hapticFeedback) return;
      const newHapticFeedback = initHapticFeedback();
      setHapticFeedback(newHapticFeedback);
    } catch (error) {
      console.log("🚀 ~ useEffect ~ error:", error);
    }
  });
  /**
   * Get affID from URL of bot app
   */
  const [affID, setAffID] = useState<string | undefined>(undefined);
  const [termOfUseData, setTermOfUseData] = useState<any>();
  const [generalSetting, setGeneralSetting] = useState<any>();
  const [walletSetting, setWalletSetting] = useState<any>();
  const [networksSetting, setNetworksSetting] = useState<any>();
  const runEffectNavigation = (effectType?: "error" | "success") => {
    try {
      if (effectType == "error") {
        return;
      }
      if (effectType == "success") {
        hapticFeedback.impactOccurred("success");
        return;
      }
      hapticFeedback.impactOccurred("medium");
    } catch (err) {}
  };
  useEffect(() => {
    (async () => {
      const [languageData, iconsDataRes, kycData, networksData, poolStake, affSetting, termOfUseDataRes, generalSettingDataRes, walletsSettingDataRes, currenciesDataRes, autoRouteSettingRes, otpComfirmationSettingRes, appVersionInfoRes, questionsDataRes] = await Promise.allSettled([fetchLanguageData(), fetchIconsData(), fetchKycSetting(), fetchNetworkSetting(), fetchPoolStakeSetting(), fetchAffSettingSetting(), fetchTermOfUseData(), fetchSettingGeneral(), fetchWalletSetting(), fetchCurrenciesData(), fetchAutoRouteSetting(), fetchOtpComfirmationsSetting(), getAppVersionInfo(), fetchQuestionSetting()]);
      if (languageData.status === "fulfilled") {
        setLanguageData(languageData.value);
        localStorage.setItem("language", JSON.stringify(languageData.value));
      }
      if (iconsDataRes.status === "fulfilled") {
        setIconsData(iconsDataRes.value);
      }
      if (kycData.status === "fulfilled") {
        try {
          setKycData(kycData.value);
          setDocumentsKYCData(kycData.value);
          let countriesKYC: any[] = [];
          kycData.value?.forEach((doc: any) => {
            doc?.country?.forEach((country: any) => {
              const existCountry = countriesKYC?.find(e => e.id == country.id);
              if (!existCountry) {
                countriesKYC.push(country);
              }
            });
          });
          setCountriesData(countriesKYC);
          setCountriesKYCData(countriesKYC);
        } catch (err) {
          console.log("🚀 ~ err:", err);
        }
      }
      if (networksData.status === "fulfilled") {
        setNetworksSetting(networksData.value);
      }
      if (poolStake.status === "fulfilled") {
        poolStakeSetting.current = poolStake.value;
      }
      if (affSetting.status === "fulfilled") {
        affSettingData.current = affSetting.value;
      }
      if (termOfUseDataRes.status === "fulfilled") {
        setTermOfUseData(termOfUseDataRes.value?.find((item: any) => item?.key == "terms_of_use"));
        setRankTermOfServiceData(termOfUseDataRes.value?.filter((item: any) => item?.key.includes("term_rank")));
        setRichtextData(termOfUseDataRes.value);
      }
      if (generalSettingDataRes.status === "fulfilled") {
        setGeneralSetting(generalSettingDataRes.value);
      }
      if (walletsSettingDataRes.status === "fulfilled") {
        setWalletSetting(walletsSettingDataRes.value);
      }
      if (currenciesDataRes.status === "fulfilled") {
        setCurrenciesData(currenciesDataRes.value);
      }
      if (autoRouteSettingRes.status === "fulfilled") {
        setRouteSetting(autoRouteSettingRes.value);
      }
      if (otpComfirmationSettingRes.status === "fulfilled") {
        setOtpComfirmationData(otpComfirmationSettingRes.value);
      }
      if (appVersionInfoRes.status === "fulfilled") {
        setAppVersionInfo(appVersionInfoRes.value?.data);
      }
      if (questionsDataRes.status === "fulfilled") {
        setQuestionsData(questionsDataRes.value);
      }
    })();
    NAVBAR_ITEMS.map(e => {
      router.prefetch(e.path);
    });
  }, []);
  //set selected country only once
  useEffect(() => {
    //wait for countries data and kyc data
    if (!countriesKYCData || !kycDataUser || !!selectedCountry || !userInfo) return;
    const userCountry = countriesKYCData.find((c: any) => c.name == userInfo?.country);
    if (kycDataUser?.kycStatus == "not_found") {
      setSelectedCountry(userCountry ?? countriesKYCData[0]);
      return;
    }
    const preSelectedCountry = countriesKYCData?.find((e: any) => e?.id == kycDataUser?.userKYC?.country_id);
    setSelectedCountry(preSelectedCountry ?? userCountry ?? countriesKYCData[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesKYCData, kycDataUser, userInfo]);

  //set documents by country selected
  useEffect(() => {
    const newDocumentsByCountry = documentsKYCData?.filter((doc: any) => {
      const country = doc.country?.find((e: any) => e.id == selectedCountry?.id);
      return !!country;
    });
    setDocumentsByCountry(newDocumentsByCountry);
  }, [selectedCountry, documentsKYCData]);
  //update document selected only once
  useEffect(() => {
    if (!documentsByCountry || !kycDataUser || !!selectedDocument) return;
    if (kycDataUser?.kycStatus == "not_found") {
      setSelectedDocument(documentsByCountry[0]);
      return;
    }
    const preSelectedDocData = documentsByCountry?.find((e: any) => e.id == kycDataUser?.userKYC?.type_id);
    setSelectedDocument(preSelectedDocData ?? documentsByCountry[0]);
  }, [documentsByCountry, kycDataUser]);
  useEffect(() => {
    if (!selectedDocument) return;
    if (documentsByCountry.some((e: any) => e.id == selectedDocument?.id)) {
      return;
    }
    setSelectedDocument(documentsByCountry[0]);
  }, [documentsByCountry]);
  //update render images
  useEffect(() => {
    if (!kycDataUser) return;
    let preKycImages = {};
    kycDataUser?.userKYC?.images?.forEach((image: any) => {
      preKycImages = {
        ...preKycImages,
        [image?.key ?? ""]: image?.base64
      };
    });
    let notRejectedImages = {};
    kycDataUser?.userKYC?.images?.forEach((e: any) => {
      if (e.status != "rejected") {
        notRejectedImages = {
          ...notRejectedImages,
          [e.key ?? ""]: e?.base64
        };
      }
    });
    !kycImages && setKycImages(notRejectedImages);
    !preKycImagesSubmit && setPreKycImagesSubmit(preKycImages);
    let preDocData = {
      ...(kycDataUser?.userKYC?.data_document?.data ?? {})
    };
    !docData && setDocData(preDocData);
    console.log("🚀 ~ useEffect ~ preDocData:", preDocData);
  }, [kycDataUser]);
  useEffect(() => {
    // if (!!docData) return;
    const images = selectedDocument?.image_kycs;
    const length = images?.length;
    if (!length || length <= 0) return;
    const result = [];
    for (let i = 0; i < length; i++) {
      const key = images[i]?.key;
      if (!key) continue;
      if (!key.includes(":")) {
        result.push([images[i]]);
        continue;
      }
      const prefixKey = key.split(":")?.[0];
      const preItems = images.slice(0, i);
      const preSamePrefixKeyItem = preItems?.find((e: any) => e.key?.startsWith(`${prefixKey}:`));
      if (!!preSamePrefixKeyItem) {
        continue;
      }
      const theSamePrefixKeyItems = images?.filter((e: any) => e.key?.startsWith(`${prefixKey}:`));
      result.push(theSamePrefixKeyItems);
    }
    setRenderImages(result);
  }, [selectedDocument]);
  const getMostLockTime = (lockTimesPackages: any) => {
    let lockTimesPackage;
    if (lockTimesPackages?.length == 1) {
      lockTimesPackage = lockTimesPackages[0];
    } else if (lockTimesPackages?.length > 1) {
      let maxProfit = 0;
      lockTimesPackages.forEach((lock: any) => {
        const profit = lock?.apr / lock?.secondsLock;
        if (profit > maxProfit) {
          lockTimesPackage = lock;
          maxProfit = profit;
        }
      });
    }
    return lockTimesPackage;
  };
  const getAprByContract = (address?: string) => {
    if (!address) return;
    const lockTimes = campaignsData?.details?.find((detail: any) => detail?.investableTokens?.some((investableToken: any) => investableToken?.contractAddress == address))?.lockTimes?.filter((lockTime: any) => compareDates(Date.now(), lockTime?.start_time) >= 0 && compareDates(Date.now(), lockTime?.end_time) < 0);
    const mostApr = getMostLockTime(lockTimes);
    return mostApr?.apr || poolStakeSetting.current?.find((e: any) => e.type == "boost")?.token_on_block_time;
  };
  const getLockTimesByContract = (address?: string): {
    locktimeDefault?: LockTime;
    locktimes?: LockTime[];
  } | undefined => {
    if (!address) return undefined;
    const locktimes = campaignsData?.details?.find((detail: any) => detail?.investableTokens?.some((investableToken: any) => investableToken?.contractAddress == address))?.lockTimes?.filter((lockTime: any) => compareDates(Date.now(), lockTime?.start_time) >= 0 && compareDates(Date.now(), lockTime?.end_time) < 0);
    console.log("🚀 ~ GlobalDataProvider ~ locktimes:", locktimes);
    const locktimeDefault = getMostLockTime(locktimes);
    console.log("🚀 ~ GlobalDataProvider ~ locktimeDefault:", locktimeDefault);
    return {
      locktimeDefault,
      locktimes
    };
  };
  const getSecondsLockByContract = (address?: string) => {
    if (!address) return;
    return campaignsData?.details?.find((detail: any) => detail?.investableTokens?.some((investableToken: any) => investableToken?.contractAddress == address))?.lockTimes?.find((lockTime: any) => compareDates(Date.now(), lockTime?.start_time) >= 0 && compareDates(Date.now(), lockTime?.end_time) < 0)?.secondsLock || poolStakeSetting.current?.find((e: any) => e.type == "boost")?.block_time_withdraw_origin;
  };
  const getTokenRewardsByContract = (address?: string) => {
    if (!address) return;
    return campaignsData?.details?.find((detail: any) => detail?.investableTokens?.some((investableToken: any) => investableToken?.contractAddress == address))?.tokenReward;
  };
  const checkIsTele = () => {
    let isTele = true;
    isTMA().then(res => {
      console.log("🚀 ~ checkIsTele ~ isTele:", res);
      isTele = res;
    });
    return isTele;
  };
  useEffect(() => {
    document.addEventListener("gesturestart", function (e) {
      e.preventDefault();
    });
    try {
      //! Not available in version < 7.7
      const [swipeBehavior] = initSwipeBehavior();
      swipeBehavior.disableVerticalSwipe();
    } catch (e) {}
    return () => {
      document.removeEventListener("gesturestart", function (e) {
        e.preventDefault();
      });
    };
  }, []);
  useEffect(() => {
    try {
      if (NAVBAR_ITEMS.find(e => e.path.replace("/", "") == pathname.replace("/", "")) || pathname.replace("/", "") == "onboard" || pathname.replace("/", "") == "verified-waiting" || pathname.replace("/", "") == "aff_Id") {
        teleBackButton.hide();
      } else {
        teleBackButton.show();
      }
    } catch (error) {}
  }, [pathname, teleBackButton]);
  const havePendingTransaction = useMemo(() => {
    if (!activityData) return false;
    const isPending = activityData.some((item: any) => item.status == "pending" && item?.code);
    console.log("🚀 ~ useMemo ~ isPending:", isPending);
    return isPending;
  }, [activityData]);
  return <GlobalContext.Provider value={{
    activityData,
    setActivityData,
    languageData,
    translate,
    getIcon,
    tokensRate: tokensRate.current,
    tokensRateRef: tokensRate,
    referralData,
    setReferralData,
    affiliateData,
    setAffiliateData,
    poolStakeSetting,
    rankData,
    setRankData,
    maxoutData,
    setMaxoutData,
    affSettingData,
    affID,
    setAffID,
    affiliateDataHistory,
    setAffiliateDataHistory,
    imageData,
    autoSub,
    setAutoSub,
    chartData,
    kycData,
    countriesData,
    kycDataUser,
    setKycDataUser,
    triggerHapticFeedBack,
    hapticFeedback,
    globalKycData,
    setGlobalKycData,
    getImageFromCMS,
    campaignsData,
    setCampaignsData,
    generalAffiliateData,
    setGeneralAffiliateData,
    getAprByContract,
    getSecondsLockByContract,
    getTokenRewardsByContract,
    portfolioData,
    setPortfolioData,
    isCheckedTermOfUse,
    setIsCheckedTermOfUse,
    termOfUseData,
    setTermOfUseData,
    showNavbar,
    setShowNavbar,
    isAccessByAffLink,
    setIsAccessByAffLink,
    hideLanding,
    setHideLanding,
    selectedFriend,
    setSelectedFriend,
    detailPageAnimation,
    setDetailPageAnimation,
    generalSetting,
    setGeneralSetting,
    walletSetting,
    setWalletSetting,
    transaction,
    setTransaction,
    selectedCardGlobal,
    setSelectedCardGlobal,
    countriesKYCData,
    setCountriesKYCData,
    documentsKYCData,
    setDocumentsKYCData,
    selectedCountry,
    setSelectedCountry,
    documentsByCountry,
    setDocumentsByCountry,
    selectedDocument,
    setSelectedDocument,
    kycDataUpload,
    setKYCDataUpload,
    acceptKYC,
    setAcceptKYC,
    kycImages,
    setKycImages,
    renderImages,
    setRenderImages,
    docData,
    setDocData,
    preKycImagesSubmit,
    setPreKycImagesSubmit,
    userInfo,
    setUserInfo,
    announcementData,
    setAnnouncementData,
    submitKYCStatus,
    setSubmitKYCStatus,
    overriedOpen,
    setOverriedOpen,
    currenciesData,
    setCurrenciesData,
    isSubmitKyc,
    setIsSubmitKyc,
    connectedSocialsData,
    setConnectedSocialsData,
    portfolioProfitData,
    setPortfolioProfitData,
    portfolioAmountData,
    setPortfolioAmountData,
    contractHistory,
    setContractHistory,
    expendedAffiliateMember,
    setExpendedAffiliateMember,
    checkManagementPackageData,
    setCheckManagementPackageData,
    rankTermOfServiceData,
    setRankTermOfServiceData,
    unsignedSignature,
    setUnsignedSignature,
    coupponsData,
    setCoupponsData,
    affiliateViewing,
    setAffiliateViewing,
    backButton: teleBackButton,
    setBackButton: setTeleBackButton,
    isCheckedContract,
    setIsCheckedContract,
    isSignaturePadEmpty,
    setIsSignaturePadEmpty,
    checkIsTele,
    setChartData,
    affiliateDataOverview,
    setAffiliateDataOverview,
    routeSetting,
    setRouteSetting,
    investRounds,
    setInvestRounds,
    isCheckKycForBonus,
    setIsCheckKycForBonus,
    loadingSignature,
    setLoadingSignature,
    isCheckedTermOfUseConnectBank,
    setIsCheckedTermOfUseConnectBank,
    runEffectNavigation,
    otpComfirmationData,
    authenInfo,
    setAuthenInfo,
    getLockTimesByContract,
    giftCardsData,
    setGiftCardsData,
    userWallets,
    setUserWallets,
    networksSetting,
    sharedCoupons,
    setSharedCoupons,
    rewardFilterTab,
    setRewardFilterTab,
    check2FA,
    setCheck2FA,
    nft,
    setNft,
    appVersionInfo,
    selectedCouponForSend,
    setSelectedCouponForSend,
    selectedCouponForUse,
    setSelectedCouponForUse,
    getMostLockTime,
    questionsData,
    deviceInfo,
    setDeviceInfo,
    meDevice,
    setMeDevice,
    amountDatesSelected,
    setAmountDatesSelected,
    profitDatesSelected,
    setProfitDatesSelected,
    currentDevice,
    setCurrentDevice,
    isSendGif,
    setIsSendGif,
    isUseBiometryForPinCode,
    setIsUseBiometryForPinCode,
    NFTNetworkSelected,
    setNFTNetworkSelected,
    mediaToCreateNFT,
    setMediaToCreateNFT,
    appliedGiftCard,
    setAppliedSelectedGiftCard,
    missionsData,
    setMissionsData,
    personalNft,
    setPersonalNft,
    hideBottomNavbar,
    setHideBottomNavbar,
    cycleVestingClaimed,
    setCycleVestingClaimed,
    currentDeviceRef,
    isOpenGiftCardModal,
    setIsOpenGiftCardModal,
    activityDetail,
    setActivityDetail,
    reviewActivityCardData,
    setReviewActivityCardData,
    activeActivityTypeActive,
    setActiveActivityTypeActive,
    page,
    setPage,
    isOpenComingSoon,
    onOpenComingSoon,
    closeComingSoon,
    pageMission,
    setPageMission,
    suggestedFriends,
    setSuggestedFriends,
    isPrefetchingSuggestedFriends,
    setIsPrefetchingSuggestedFriends,
    statusBarHeight,
    setStatusBarHeight,
    isLimitSize,
    setIsLimitSize,
    screenSize,
    setScreenSize,
    couponTabs,
    setCouponTabs,
    appliedCoupon,
    setAppliedCoupon,
    selectedPresaleToken,
    setSelectedPresaleToken,
    boostAmount,
    setBoostAmount,
    isOpenConfirmPresale,
    onOpenConfirmPresale,
    onOpenChangeConfirmPresale,
    onCloseConfirmPresale,
    clickedActivity,
    setClickedActivity,
    detailTransactionData,
    setDetailTransactionData,
    isMobileApp,
    setIsMobileApp,
    selectedLockTime,
    setSelectedLockTime,
    boostAprData,
    setBoostAprData,
    selectedPayment,
    setSelectedPayment,
    packageInfo,
    setPackagesInfo,
    packagePagination,
    setPackagePagination,
    packageLoading,
    setPackageLoading,
    subPaymentFeeData,
    setSubPaymentFeeData,
    havePendingTransaction,
    limitInvest,
    setLimitInvest,
    richtextData,
    setRichtextData
  }} data-sentry-element="unknown" data-sentry-component="GlobalDataProvider" data-sentry-source-file="index.tsx">
            {children}
            <Modal isOpen={isOpenComingSoon} placement="bottom" onOpenChange={onComingSoonChange} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="index.tsx">
                <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                    <ModalLayout modalKey="d251504b-3f0b-4b51-b6d9-66cb57aa608gh2" title={translate("Coming soon popup title")} onClose={closeComingSoon} className="" data-sentry-element="ModalLayout" data-sentry-source-file="index.tsx">
                        <ComingSoonContent onClickButton={closeComingSoon} data-sentry-element="ComingSoonContent" data-sentry-source-file="index.tsx" />
                    </ModalLayout>
                </ModalContent>
            </Modal>
        </GlobalContext.Provider>;
}
export default GlobalDataProvider;
export const useGlobalData = () => {
  const context = useContext(GlobalContext);
  return context ?? {};
};